module.exports = __webpack_public_path__ + "img/WIP.a3e376e4.webp";